import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LineAuthService } from '../../../lib/services/line-auth.service';

@Component({
  selector: 'app-line-callback',
  standalone: true,
  template: `
    <div class="d-flex justify-content-center align-items-center min-vh-100">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">로딩중...</span>
      </div>
    </div>
  `,
})
export class LineCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private lineAuthService: LineAuthService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(({ code }) => {
      if (code) {
        this.lineAuthService.handleCallback(code).subscribe({
          error: (error) => {
            console.error('LINE 프로필 조회 에러:', error);
            this.router.navigate(['/requests']);
          },
        });
      }
    });
  }
}
